import dynamic from 'next/dynamic';
export const SvgIcon = dynamic(() => import('./Icon/SvgIcon'), {
    ssr: false,
});
export default SvgIcon;
export const EFLightning = dynamic(() => import('./Icon/EFLightning'), {
    ssr: false,
});
export const EFLightningH5 = dynamic(() => import('./Icon/EFLightningH5'), {
    ssr: false,
});
export const EFLeftMore = dynamic(() => import('./Icon/EFLeftMore'), {
    ssr: false,
});
export const EFRightMore = dynamic(() => import('./Icon/EFRightMore'), {
    ssr: false,
});
export const EFButtonMore = dynamic(() => import('./Icon/EFButtonMore'), {
    ssr: false,
});
export const EFLightLeftH5 = dynamic(() => import('./Icon/EFLightLeftH5'), {
    ssr: false,
});
export const EFLightRightH5 = dynamic(() => import('./Icon/EFLightRightH5'), {
    ssr: false,
});
export const EFCapacity = dynamic(() => import('./Icon/EFCapacity'), {
    ssr: false,
});
export const EFWatch = dynamic(() => import('./Icon/EFWatch'), {
    ssr: false,
});
export const EFFully = dynamic(() => import('./Icon/EFFully'), {
    ssr: false,
});
export const EFDoubleLight = dynamic(() => import('./Icon/EFDoubleLight'), {
    ssr: false,
});
export const EFOutput = dynamic(() => import('./Icon/EFOutput'), {
    ssr: false,
});
export const EFOutput2 = dynamic(() => import('./Icon/EFOutput2'), {
    ssr: false,
});
export const EFStream = dynamic(() => import('./Icon/EFStream'), {
    ssr: false,
});
export const EFPort = dynamic(() => import('./Icon/EFPort'), {
    ssr: false,
});
export const EFPort1 = dynamic(() => import('./Icon/EFPort1'), {
    ssr: false,
});
export const EFPort2 = dynamic(() => import('./Icon/EFPort2'), {
    ssr: false,
});
export const EFPort3 = dynamic(() => import('./Icon/EFPort3'), {
    ssr: false,
});
export const EFLBS = dynamic(() => import('./Icon/EFLBS'), {
    ssr: false,
});
export const EFLFP = dynamic(() => import('./Icon/EFLFP'), {
    ssr: false,
});
export const EFCycle = dynamic(() => import('./Icon/EFCycle'), {
    ssr: false,
});
export const EFApp = dynamic(() => import('./Icon/EFApp'), {
    ssr: false,
});
export const EFWarranty = dynamic(() => import('./Icon/EFWarranty'), {
    ssr: false,
});
export const EFWarranty1 = dynamic(() => import('./Icon/EFWarranty1'), {
    ssr: false,
});
export const EFAmazon = dynamic(() => import('./Icon/EFAmazon'), {
    ssr: false,
});
export const EFRakuten = dynamic(() => import('./Icon/EFRakuten'), {
    ssr: false,
});
export const EFShopify = dynamic(() => import('./Icon/EFShopify'), {
    ssr: false,
});
export const EFJD = dynamic(() => import('./Icon/EFJD'), {
    ssr: false,
});
export const EFRheinland = dynamic(() => import('./Icon/EFRheinland'), {
    ssr: false,
});
export const EFXBoost = dynamic(() => import('./Icon/EFXBoost'), {
    ssr: false,
});
export const EFXBoostH5 = dynamic(() => import('./Icon/EFXBoostH5'), {
    ssr: false,
});
export const EFCPAPH5 = dynamic(() => import('./Icon/EFCPAPH5'), {
    ssr: false,
});
export const EFFishTankH5 = dynamic(() => import('./Icon/EFFishTankH5'), {
    ssr: false,
});
export const EFWiFiRouterH5 = dynamic(() => import('./Icon/EFWiFiRouterH5'), {
    ssr: false,
});
export const EFFullyCharge = dynamic(() => import('./Icon/EFFullyCharge'), {
    ssr: false,
});
export const EF5XFaster = dynamic(() => import('./Icon/EF5XFaster'), {
    ssr: false,
});
export const EFHandyBg = dynamic(() => import('./Icon/EFHandyBg'), {
    ssr: false,
});
export const EFLimt = dynamic(() => import('./Icon/EFLimt'), {
    ssr: false,
});
export const EFCPAP = dynamic(() => import('./Icon/EFCPAP'), {
    ssr: false,
});
export const EFTank = dynamic(() => import('./Icon/EFTank'), {
    ssr: false,
});
export const EFWifi = dynamic(() => import('./Icon/EFWifi'), {
    ssr: false,
});
export const EFarrow = dynamic(() => import('./Icon/EFarrow'), {
    ssr: false,
});
export const EFPersonBackground = dynamic(() => import('./Icon/EFPersonBackground'), {
    ssr: false,
});

export function EFxboost(props: any) {
    return (
        <svg
            width="129px"
            height="35px"
            viewBox="0 0 129 35"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            {...props}
        >
            <defs>
                <linearGradient x1="55.4167684%" y1="33.2825926%" x2="90.2003165%" y2="6.53540966%" id="linearGradient-EFxboost">
                    <stop stopColor="#A28F61" offset="0%"></stop>
                    <stop stopColor="#FADF9A" offset="81.0000002%"></stop>
                    <stop stopColor="#FAECAF" offset="100%"></stop>
                </linearGradient>
            </defs>
            <g id="V1.2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="River-2-详情页" transform="translate(-1081.000000, -1660.000000)" fillRule="nonzero">
                    <g id="编组备份" transform="translate(400.000000, 1360.000000)">
                        <g id="编组-46" transform="translate(681.695452, 300.000000)">
                            <g id="Group-2" transform="translate(0.000000, 7.567568)" fill="#FFFFFF">
                                <path
                                    d="M51.4484206,3.46775491 C51.782113,2.65530309 51.6998864,1.73260187 51.2277102,0.991100599 C50.7405846,0.328982591 49.9490593,-0.0426472462 49.1251355,0.00390972154 L36.3006005,0.00390972154 L35.3538635,2.79807607 L48.1319316,2.79807607 C48.2746911,2.78796916 48.412734,2.85113384 48.4978475,2.96550018 C48.5803495,3.09748422 48.5933388,3.26103402 48.5326953,3.40425073 L47.5917676,6.17532828 L38.438023,6.17532828 L37.5087098,8.96372462 L46.6334116,8.96372462 L45.7099079,11.6828386 C45.5694016,12.0566228 45.2217844,12.3140616 44.8212478,12.3409688 L35.0692601,12.3409688 L37.9733643,3.77372717 L35.0169861,3.77372717 L31.1545236,15.1351351 L44.0487588,15.1351351 C46.1178038,15.0041048 47.9134045,13.6700803 48.6256288,11.7347942 L50.4087499,6.48130056 L50.513298,6.17532828 L50.5191074,6.17532828 L51.4484206,3.46775491 Z"
                                    id="路径"
                                ></path>
                                <path
                                    d="M68.2292101,0.00313383109 L57.7324036,0.00313383109 C55.6824812,0.131924224 53.9025554,1.46611784 53.1968169,3.40291103 L50.4145276,11.6801257 C50.0871674,12.4928798 50.1684271,13.4140483 50.6329701,14.1563692 C51.1149015,14.8078815 51.8895388,15.1740318 52.6966935,15.1318498 L63.1935041,15.1318498 C65.2412872,15.0008413 67.0184358,13.6670378 67.7233414,11.7320727 L70.511377,3.46640469 C70.8426957,2.6503438 70.7613482,1.72388443 70.2929346,0.978623203 C69.810332,0.327934657 69.0361602,-0.0380034616 68.2292101,0.00313383109 Z M67.2002278,2.79683688 C67.3415203,2.78673162 67.4781444,2.84988585 67.5623833,2.96423322 C67.6440378,3.09619539 67.6568935,3.25971806 67.5968732,3.40291103 L64.8145884,11.6801257 C64.6767502,12.054769 64.3320141,12.3126854 63.9350645,12.3381468 L53.7199306,12.3381468 C53.5790325,12.3461227 53.4433685,12.2834205 53.3577748,12.1707592 C53.2788318,12.0379162 53.2660755,11.8757078 53.3232808,11.7320727 L56.1113193,3.46640469 C56.2455028,3.08723426 56.591018,2.82419728 56.9908433,2.79683688 L67.2002278,2.79683688 Z"
                                    id="形状"
                                ></path>
                                <path
                                    d="M87.290861,0.00328520157 L76.7940536,0.00328520157 C74.7462703,0.134292506 72.9691175,1.46808245 72.2642118,3.40302825 L69.476177,11.6801604 C69.1488168,12.4929063 69.2300763,13.4140655 69.6946194,14.1563791 C70.1765507,14.8078848 70.9511838,15.1740315 71.7583386,15.1318499 L82.2551543,15.1318499 C84.3029377,15.0008426 86.0800821,13.6670526 86.7849877,11.7321068 L89.5730279,3.46652127 C89.9043466,2.65046857 89.8229946,1.7240185 89.3545812,0.978764761 C88.8726499,0.327259047 88.0980156,-0.0388964342 87.290861,0.00328520157 Z M83.8762344,11.6801604 C83.735968,12.0529697 83.3926081,12.3098543 82.9967105,12.3381748 L72.7873254,12.3381748 C72.646033,12.34828 72.5094087,12.2851352 72.4251698,12.170789 C72.3435154,12.0388281 72.3306597,11.8752983 72.3906801,11.7321068 L75.1729648,3.46652127 C75.3108031,3.09188167 75.6555391,2.8339679 76.0524887,2.80850676 L86.2618783,2.80850676 C86.4031709,2.79840162 86.5397907,2.8615464 86.6240297,2.97589264 C86.7018388,3.10488374 86.7146159,3.26313545 86.6585195,3.40302825 L83.8762344,11.6801604 Z"
                                    id="形状"
                                ></path>
                                <polygon id="路径" points="20.4963971 10.3556188 30.7340258 10.3556188 31.7694155 6.87055477 21.5317869 6.87055477"></polygon>
                                <polygon
                                    id="路径"
                                    points="112.619916 0 111.705364 2.79488832 117.839553 2.79488832 113.813294 15.1351351 116.930575 15.1351351 120.956834 2.79488832 127.091022 2.79488832 128 0"
                                ></polygon>
                                <polygon id="路径" points="13.5395105 15.1351351 17.6269015 15.1351351 9.72390028 0 5.63650921 0"></polygon>
                                <polygon id="路径" points="5.09868638 15.1351351 11.2730184 10.7923748 9.70512746 8.26458037 0 15.1351351"></polygon>
                                <polygon id="路径" points="18.7676892 0 12.7077662 4.37268054 14.3293505 6.87055477 23.9807846 0"></polygon>
                            </g>
                            <polygon
                                id="路径"
                                fill="url(#linearGradient-EFxboost)"
                                points="90.4667392 13.5216774 98.3023334 13.5216774 81.1940299 35 108.839248 10.8405032 101.003654 10.8405032 111.761194 0 101.534375 0"
                            ></polygon>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
